<div class="d-flex flex-column p-1 py-3 align-middle">
  <div class="d-flex">
    <span class="align-middle text-uppercase" [innerHTML]="article?.ref | makeBoldPartOfText:searchText"></span>
    <span class="badge badge-secondary p-2 mr-2 ml-2 align-middle">{{article?.widget?.width}}
    X {{article?.widget?.height}}</span>
    <span class="align-middle"> ({{article?.widget?.width * fieldMM}} X {{article?.widget?.height * heightMM}}
    mm) </span>
    @if (article?.ratedCurrentDescription; as amperesDescription) {
      <span class="align-middle ml-2">{{amperesDescription}}</span>
    }
  </div>
</div>
@if (searchText) {
  <div>
    @if (article?.eNumber?.toString() | isSubstringPartOfString:searchText) {
      <div class="align-middle d-flex text-color-medium-grey">
        <ng-container i18n="@@app.enumber">Enumber</ng-container>:<div class="pl-1 text-uppercase" [innerHTML]="article?.eNumber?.toString() | makeBoldPartOfText:searchText"></div>
      </div>
    }
    @if (article?.description | isSubstringPartOfString:searchText) {
      <div [innerHTML]="article?.description | makeBoldPartOfText:searchText"></div>
    }
  </div>
}
